import styled from "styled-components"

export const AiToggleWrap = styled.div`
  display: flex;
  gap: 10px;
`
